/**
 * The ChoicelistMessagesTemplate contains all the data needed to hydrate a messages component
 *
 * @typedef {Object}      defaultChoicelistMessagesData
 *
 * @property {String}     extraClasses      - Extra classes if needed
 */

export const defaultChoicelistMessagesData = {
  extraClasses: ''
}

export const ChoicelistMessagesTemplate = (d) => `
  ${d
    ? `
        ${d.map(message => `
          <div class="c-choice-list__message">
            <i class="m-icon m-icon--warning-circle"></i>
            <span>${message}</span>
          </div>
    `).join('')}
      `
    : ''}
`
